import { AppConstants, ORION_IMG_URL } from "../../../utils/AppConstants";
import * as _ from "lodash";
import {ISymptom} from "@curefit/care-common";
import * as React from "react";

export interface ChiefComplaintsPlanPDFProps {
    id: string;
    planItem: any;
}

type Props = ChiefComplaintsPlanPDFProps

const ChiefComplaintsPlanPDFTemplate: React.StatelessComponent<Props> = (props: Props) => {
    let id = props.id;
    let planItem = props.planItem[id];
    let itemsToIterate = planItem.chiefComplaints.patientComplaints ;
    return (
        <div id={id} className={`prescription-grid-row external-row`}>
            <div className="prescription-card-content">
                <div className={`${id}-header brandon-bold`}><img src={ORION_IMG_URL + "icons/symptom-header-icon.svg"}
                                                                  className={"header-icon"}/> SYMPTOMS
                </div>
                <div id={`${id}-subsection`} className="prescription-description">
                    <ul>
                        {_.map(itemsToIterate, (symptom: ISymptom, index) => {
                            return <div key={`${symptom.complaint && symptom.complaint.internalValue}-${index}`} className={"chiefComplaint-item"}>
                                <li>
                                    <div className={"symptom-name"}>
                                        {symptom.complaint && symptom.complaint.displayValue}
                                        {!_.isEmpty(symptom.duration) && !_.isEmpty(symptom.duration.unit) ?
                                            ` - ${symptom.duration.count} ${AppConstants.FrequencyUnit[symptom.duration.unit]}${symptom.duration.count > 1 ? "s" : ""}` : ""}
                                        {!_.isEmpty(symptom.comment) ? `, ${symptom.comment}` : ""}
                                    </div>
                                </li>
                            </div>
                        })}
                    </ul>
                    {planItem.noPresentingIllness &&
                    <p className={"prescription-subheading"}>No presenting illness</p>}
                    {planItem.publicNotes &&
                    <p>{planItem.publicNotes}</p>}
                </div>
            </div>
        </div>
    )
}


export default ChiefComplaintsPlanPDFTemplate;